import { InstantClientSelect } from '@/components/selects/ClientSelect';
import { useFormikContext } from 'formik';
import React from 'react';
import FieldFormControl from '../FieldFormControl';

const ClientSelectField = ({ field, filterProspects, disabled }) => {
	const { setFieldValue, values, getFieldMeta, getFieldHelpers, getFieldProps } =
		useFormikContext();
	const { onBlur: onFieldBlur } = getFieldProps(field.name);
	const { setTouched } = getFieldHelpers(field.name);

	const onBlur = (e) => {
		onFieldBlur(e);
		setTouched(true, true);
	};

	const { error: errorMessage, touched } = getFieldMeta(field.name);
	const error = touched && Boolean(errorMessage);

	const nameField = field.name.endsWith('Id')
		? `${field.name.slice(0, -2)}Name`
		: `${field.name}Name`;

	return (
		<FieldFormControl {...{ disabled, field }}>
			<InstantClientSelect
				clientId={values[field.name]}
				clientName={values[nameField]}
				filterProspects={true}
				setClient={(newClient) => {
					console.log('Here is the selected client: ', newClient);
					setFieldValue(field.name, newClient?.insightId);
					setFieldValue(nameField, newClient?.name ?? '');
				}}
				{...{ filterProspects, error, onBlur, disabled }}
			/>
		</FieldFormControl>
	);
};

export default ClientSelectField;
